<script lang="ts">
/**
 * List form errors for the user to see.
 */
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    messages: {
      type: Array as unknown as () => {
        message: string; // note messages should be pre-translated
        hint?: string;
      }[],
      required: true,
    },
  },
});
</script>

<template>
  <div
    v-if="messages.length > 0"
    class="hekate-error-container"
  >
    <p
      v-for="(error, ii) in messages"
      :key="`err-msg-${ii}`"
      :hint="error.hint"
      class="hekate-error-message"
    >
      {{ error.message }}
    </p>
  </div>
</template>

<style lang="scss">
@use '../../../style/vars.scss' as vars;

.top-message {
  border-top: 1px solid vars.$color-error;
}

.hekate-error-message {
  border-bottom: 1px solid vars.$color-error;
  border-left: 1px solid vars.$color-error;
  border-right: 1px solid vars.$color-error;
  color: vars.$color-error;
  border-radius: 0;
  background: vars.$color-error-background;
  display: block;
  padding-left: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
